import { ORDER_STATUS } from "@miplatform/constants";
import { mdiFileDocumentCheckOutline, mdiFileDocumentOutline } from "@mdi/js";

export const getWorkOrderTabStats = (theme, workOrders = []) => {
  const WORK_ORDERS = "Work Orders";
  if (!workOrders || workOrders.length === 0)
    return {
      icon: mdiFileDocumentOutline,
      color: theme.palette.grey.medium,
      label: `0/0 ${WORK_ORDERS}`,
      count: "0/0",
    };

  const completedCount = workOrders.filter(
    (wo) => wo.status === "Complete"
  ).length;

  const label = `${completedCount}/${workOrders.length} ${WORK_ORDERS}`;
  const count = `${completedCount}/${workOrders.length}`;

  if (completedCount === 0)
    return {
      icon: mdiFileDocumentOutline,
      color: theme.palette.grey.medium,
      label,
      count,
    };
  if (completedCount === workOrders.length)
    return {
      icon: mdiFileDocumentCheckOutline,
      color: theme.palette.success.main,
      label,
      count,
    };
  return {
    icon: mdiFileDocumentOutline,
    color: theme.palette.warning.main,
    label,
    count,
  };
};

export const getHomeOrderCardStyles = (theme, status) => {
  switch (status) {
    case ORDER_STATUS.IN_PROGRESS: {
      return {
        backgroundColor: theme.palette.white.main,
        border: `1px solid ${theme.palette.orange.main}`,
      };
    }
    default: {
      return {
        backgroundColor: theme.palette.grey.lightAccent,
      };
    }
  }
};

const getPriority = (status) => {
  if (status === ORDER_STATUS.COMPLETE) return 0;
  if (status === ORDER_STATUS.IN_PROGRESS) return 1;
  return 2;
};

export const sortOrdersByStatus = (orders = []) => {
  return [...orders].sort((a, b) => {
    const priorityA = getPriority(a.orderStatus);
    const priorityB = getPriority(b.orderStatus);

    // If same priority, sort by approvedStartDate (earlier dates first)
    if (priorityA === priorityB) {
      const dateA = new Date(a.approvedStartDate || 0);
      const dateB = new Date(b.approvedStartDate || 0);
      return dateA - dateB;
    }

    return priorityA - priorityB;
  });
};
